export const name = 'anchorsService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-anchors'
